const en = {
    '/': {
        title: '{brand} | Sportsbook, Live Casino & Instant Withdrawals',
        description: 'Play slots, live casino & bet on sports at {brand}. Crypto casino with instant withdrawals, provably fair games & 24/7 support.'
    },
    '/casino': {
        title: 'Online Casino | Slots, Blackjack & Live Dealers | {brand}',
        description: 'Play slots, blackjack, roulette & live dealers at {brand}. Hundreds of games, fast crypto deposits & instant withdrawals available 24/7.'
    },
    '/sports': {
        title: 'Online Sportsbook | Crypto Sports Betting & Odds | {brand}',
        description: 'Bet on sports at {brand}. Competitive odds on football, basketball & more. Live betting, secure crypto wagering & fast payouts.'
    },
    '/livecasino': {
        title: 'Live Casino | Blackjack, Roulette & Live Dealers | {brand}',
        description: 'Play blackjack, roulette & live casino games at {brand}. Real dealers, HD streaming & a wide selection of live tables available 24/7.'
    },
    '/slots': {
        title: 'Online Slots | Wide Variety of Casino Slots | {brand}',
        description: 'Spin a massive collection of slots at {brand}. Classic fruit machines, video slots & progressives — all playable with crypto.'
    },
    '/vip': {
        title: 'VIP Program | Exclusive Rewards & Benefits | {brand}',
        description: "{brand}'s VIP program: exclusive rewards, personalised bonuses & priority support. Tailored perks for loyal players."
    },
    '/welcome-offer': {
        title: 'Welcome Bonus Offer | Sign Up & Get Your Bonus | {brand}',
        description: "Claim {brand}'s welcome bonus on your first deposit. Learn how to get started and make the most of our sign-up offer."
    },
    '/referral': {
        title: 'Referral Program | Invite Friends & Earn Rewards | {brand}',
        description: 'Refer friends to {brand} & earn rewards when they sign up and play. Share your link and collect bonuses for every referral.'
    },
    '/promotion-page': {
        title: 'Casino Promotions | Bonuses & Special Offers | {brand}',
        description: "Browse {brand}'s latest casino promotions. Current bonuses, tournaments & special events — claim your offer and start playing."
    },
    '/hotslots': {
        title: 'Hot Slots | Most Popular Casino Slots | {brand}',
        description: 'Play the hottest slot games at {brand}. Top-rated slots available with crypto.'
    },
    '/newgames': {
        title: 'New Casino Games | Latest Slots & Live Games | {brand}',
        description: 'Play the latest casino games at {brand}. Regularly updated with new slots & table games from top providers. Be first to play.'
    },
    '/populargames': {
        title: 'Popular Casino Games | Top Slots & Live Games | {brand}',
        description: 'Play the most popular casino games at {brand}. Top-rated slots & table games loved by our community, available with crypto.'
    },
    '/gameshows': {
        title: 'Live Gameshows | Play Casino Gameshows at {brand}',
        description: 'Play live casino gameshows at {brand}. Enjoy Crazy Time, Monopoly Live & more, hosted by professional dealers in real time.'
    },
    '/table_games': {
        title: 'Table Games | Blackjack, Roulette & Baccarat | {brand}',
        description: 'Play blackjack, roulette, baccarat and more table games at {brand}. All available with crypto.'
    },
    '/hotlive': {
        title: 'Popular Live Casino | Top Live Casino Games | {brand}',
        description: 'The most popular live casino games at {brand}. Play with real dealers in real time.'
    },
    '/featurebuyin': {
        title: 'Feature Buy-In Slots | Skip to Bonus Rounds | {brand}',
        description: "Skip straight to bonus rounds with {brand}'s feature buy-in slots. Instantly trigger bonus features for a chance at big wins."
    }
};
export default en;
